export default __webpack_public_path__ + "static/media/logo-white.19ee406a.png";